import { render, staticRenderFns } from "./PositionsSelectButton.vue?vue&type=template&id=3be008cd&scoped=true"
import script from "./PositionsSelectButton.vue?vue&type=script&lang=js"
export * from "./PositionsSelectButton.vue?vue&type=script&lang=js"
import style0 from "./PositionsSelectButton.vue?vue&type=style&index=0&id=3be008cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be008cd",
  null
  
)

export default component.exports